<template>
<div class="container-max">
        <div class="login-card">
        <div class="login-content">
            <h3>Login Page</h3>
            <input type="email" placeholder="Email" id="email" class="form-control" v-on:change="Clean">
            <input type="password" placeholder="Password" id="pass" class="form-control" v-on:change="Clean">
            <label for="submit" id="label" class="invisible error-message">Les champs sont vides</label>
            <div class="button-1" id="submit" v-on:click="SignIn">Login</div>
        </div>
    </div>
</div>
    
</template>



<script>
export default {
    name : 'Login',
    beforeCreate: function() {
        document.body.className = 'login';
    },
    methods : {
        SignIn: function()
        {
            const email = document.getElementById('email').value;
            const pass = document.getElementById('pass').value;
            const label = document.getElementById("label");
            if (email != "" && pass != "")
            {
                this.$auth.signInWithEmailAndPassword(email, pass).then(function() {
                    this.$router.push('/Admin')
                }.bind(this)).catch((error)=> {
                    label.textContent = "Mot de Passe ou Email incorrect";
                    label.classList.remove('invisible')
                    console.log(error);
                })
            }
            else{
                label.textContent = "Les champs sont vides";
                label.classList.remove('invisible')
                
                
                
            }

            

        },
        Clean : function (){
            const label = document.getElementById("label");
            if(!label.classList.contains('invisible'))
            {
                label.classList.add('invisible');
            }
        }
         
    }
    
}
</script>


<style scoped>


.login-card {
    box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
    width : 28%;
    padding: 1rem;
    margin: auto;
    background-color: white;
}

.container-max{
    height: 100vh;
    display: flex;
    justify-content: center;
}

.form-control {
    margin-top: 0.25rem;
}

.error-message {
    color: tomato;
    font-size: 0.75rem;
}

.button-1{
    background-color: #03A9F4;
    cursor: pointer;
    border-color: none;
    color: white;
    border-radius: 0.10rem;
    border-width:0px ;
    margin-top: 1rem;
    padding: 0.8rem;
    flex-shrink: 0;
    margin-left: 0.2rem;
    transition-duration: 0.2s;
}

.button-1:hover{
     background-color: steelblue;
}

</style>